module.exports = __webpack_public_path__ + "static/media/list-icon.91c35166.svg";